import { render, staticRenderFns } from "./DiagnosticOverviewAnalysisResults.vue?vue&type=template&id=2899a40c&scoped=true"
import script from "./DiagnosticOverviewAnalysisResults.vue?vue&type=script&lang=js"
export * from "./DiagnosticOverviewAnalysisResults.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticOverviewAnalysisResults.vue?vue&type=style&index=0&id=2899a40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899a40c",
  null
  
)

export default component.exports